import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { useSelector } from 'react-redux';

const MainNavigation = ({ isCollapsed = false, className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedBusiness = useSelector((state) => state?.business.selectedBusiness);

  const [navigationItems, setNavigationItems] = useState([]);

  // const navigationItems = [
  //   {
  //     label: 'Dashboard',
  //     path: '/admin-dashboard',
  //     icon: 'LayoutDashboard',
  //     description: 'Overview and analytics'
  //   },
  //   {
  //     label: 'Booking Management',
  //     path: '/booking-management',
  //     icon: 'ChartLine',
  //     description: 'Manage bookings'
  //   },
  //   {
  //     label: 'Staff Management',
  //     path: '/staff-management',
  //     icon: 'Users',
  //     description: 'Manage team members'
  //   },
  //   {
  //     label: 'Category Management',
  //     path: '/category-management',
  //     icon: 'FolderCog',
  //     description: 'Configure business categories'
  //   },
  //   {
  //     label: 'Service Management',
  //     path: '/service-management',
  //     icon: 'Wrench',
  //     description: 'Configure services and pricing'
  //   },
  //   {
  //     label: 'Business Settings',
  //     path: '/business-profile-settings',
  //     icon: 'Settings',
  //     description: 'Business profile and configuration'
  //   }
  // ];

  const setNavigation = () => {
    const navigationItems = [
      {
        label: 'Dashboard',
        path: '/admin-dashboard',
        icon: 'LayoutDashboard',
        description: 'Overview and analytics'
      }
    ];

    if(selectedBusiness == null) {
      setNavigationItems(navigationItems);
      return;
    }

    if(selectedBusiness.admin || selectedBusiness.owner || selectedBusiness.scanning || selectedBusiness.releasing){
      navigationItems.push(
        {
          label: 'Booking Management',
          path: '/booking-management',
          icon: 'ChartLine',
          description: 'Manage bookings'
        }
      )
    }

    if(selectedBusiness.admin || selectedBusiness.owner){
      navigationItems.push(
        {
          label: 'Staff Management',
          path: '/staff-management',
          icon: 'Users',
          description: 'Manage team members'
        },
        {
          label: 'Category Management',
          path: '/category-management',
          icon: 'FolderCog',
          description: 'Configure business categories'
        },
        {
          label: 'Service Management',
          path: '/service-management',
          icon: 'Wrench',
          description: 'Configure services and pricing'
        },
        {
          label: 'Business Settings',
          path: '/business-profile-settings',
          icon: 'Settings',
          description: 'Business profile and configuration'
        }
      )
    }

    if(selectedBusiness.admin || selectedBusiness.owner || selectedBusiness.reporting){
      navigationItems.push(
        {
          label: 'Reporting',
          path: '/reporting',
          icon: 'Landmark',
          description: 'Generate and view business reports'
        }
      )
    }

    navigationItems.push(
      {
          label: 'User Profile',
          path: '/user-profile',
          icon: 'User',
          description: 'User profile'
        }
    )


    setNavigationItems(navigationItems);
      
  }

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isActivePath = (path) => location?.pathname === path;

  useEffect(() => {
    setNavigation();
  }, [selectedBusiness]);

  return (
    <aside 
      className={`hidden lg:block fixed left-0 top-16 bottom-0 z-999 bg-card border-r border-border transition-all duration-300 ease-out ${
        isCollapsed ? 'w-16' : 'w-64'
      } ${className}`}
    >
      <div className="flex flex-col h-full">
        {/* Navigation Header */}
        <div className="p-4 border-b border-border">
          {!isCollapsed && (
            <div className="flex items-center space-x-2">
              <div className="status-indicator active"></div>
              <span className="text-sm font-medium text-muted-foreground">
                Navigation
              </span>
            </div>
          )}
        </div>

        {/* Navigation Items */}
        <nav className="flex-1 p-2 space-y-1">
          {navigationItems?.map((item) => {
            const isActive = isActivePath(item?.path);
            
            return (
              <div key={item?.path} className="relative group">
                <Button
                  variant={isActive ? 'default' : 'ghost'}
                  size={isCollapsed ? 'icon' : 'sm'}
                  onClick={() => handleNavigation(item?.path)}
                  className={`w-full transition-smooth ${
                    isCollapsed 
                      ? 'justify-center p-3' 
                      : 'justify-start'
                  } ${
                    isActive 
                      ? 'bg-primary text-primary-foreground shadow-sm' 
                      : 'hover:bg-muted hover:text-black'
                  }`}
                >
                  <Icon 
                    name={item?.icon} 
                    size={20} 
                    className={isActive ? 'text-primary-foreground' : 'text-muted-foreground'}
                  />
                  {!isCollapsed && (
                    <span className="ml-3 font-medium">
                      {item?.label}
                    </span>
                  )}
                </Button>
                {/* Tooltip for collapsed state */}
                {isCollapsed && (
                  <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-3 py-2 bg-popover border border-border rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 delay-300 z-1001 whitespace-nowrap">
                    <div className="text-sm font-medium text-popover-foreground">
                      {item?.label}
                    </div>
                    <div className="text-xs text-muted-foreground mt-1">
                      {item?.description}
                    </div>
                    {/* Tooltip arrow */}
                    <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-popover"></div>
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Navigation Footer */}
        <div className="p-4 border-t border-border">
          {!isCollapsed ? (
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div className="status-indicator active"></div>
                <span className="text-xs text-muted-foreground">
                  System Online
                </span>
              </div>
              <span className="text-xs font-mono text-muted-foreground">
                v1.0.0
              </span>
            </div>
          ) : (
            <div className="flex justify-center">
              <div className="status-indicator active"></div>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default MainNavigation;